export default "__VITE_ASSET__2jl0fMLL__"